import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import useQuery from '@hooks/useQuery'

import { loadFromMagicLink } from '@store/ducks/simulate'

export default function useMagicLink() {
  const dispatch = useDispatch()
  const magicLink = useQuery().get('magic-link')
  const hasMagicLink = !!magicLink

  useEffect(() => {
    if (hasMagicLink) {
      dispatch(loadFromMagicLink(magicLink))
    }
  }, [hasMagicLink])
  return {
    hasMagicLink,
  }
}
